import virtualClassroomManagerRoutes from 'modules/virtualClassrooms/common/routing/managerRoutes'

const routes = {
  root: `${virtualClassroomManagerRoutes.events}/create`,
}

export default routes
